import {
  Box,
  Flex,
  Icon,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { RiArrowDropDownLine, RiLogoutCircleRLine } from "react-icons/ri";
import { NavLink, useLocation } from "react-router-dom";
import { fullName } from "src/services/format";
import * as Url from "src/services/url";
import { PersonAvatar } from "./Avatar";

type Person = {
  avatar: string | null;
  first_name: string | null;
  last_name: string | null;
  email_address: string | null | undefined;
};
type Props = {
  person: Person | null | undefined;
  children?:
    | React.ReactElement<typeof MenuItem>
    | React.ReactElement<typeof MenuItem>[];
};
export const AdminMenu: React.FC<Props> = ({ person, children }) => {
  const location = useLocation();
  return (
    <Menu>
      <Flex alignItems="center" gap={2}>
        <PersonAvatar
          person={person}
          size="sm"
          boxSizing="content-box"
          borderColor="primary.300"
          borderWidth="3px"
          borderStyle="solid"
        />
        <MenuButton
          as={IconButton}
          size="sm"
          icon={<RiArrowDropDownLine size="2rem" />}
        />
      </Flex>
      <MenuList display="flex" rowGap={3} flexDirection="column" pt={4}>
        {person && (
          <Flex direction="column" alignItems="center" gap={4} px={4}>
            <PersonAvatar person={person} size="md" />
            <Flex direction="column" alignItems="center">
              <Text>{fullName(person)}</Text>
              <Text fontSize="xs" color="gray.600">
                {person.email_address ?? "Account"}
              </Text>
            </Flex>
          </Flex>
        )}
        <Flex direction="column">
          {children}
          <MenuItem
            paddingX={4}
            as={NavLink}
            to={Url.logout(location.pathname)}
            gap={2}
            borderTop="1px solid"
            borderColor="gray.200"
          >
            <Icon as={RiLogoutCircleRLine} />
            <Box>Log out</Box>
          </MenuItem>
        </Flex>
      </MenuList>
    </Menu>
  );
};
